import { module }from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let videoEl = this.el;
        let video = videoEl.getAttribute('data-video');
        let videoAlt = videoEl.getAttribute('data-video-alt');
        let videoMobile = videoEl.getAttribute('data-video-mobile');
        let videoAltMobile = videoEl.getAttribute('data-video-alt-mobile');

        let outputVideo = video ? `<source src="${video}" type="video/webm">` : '';
        let outputVideoMobile = videoMobile ? `<source src="${videoMobile}" type="video/webm">`:'';
        let outputVideoMp4 = videoAlt ? `<source src="${videoAlt}" type="video/mp4">`:'';
        let outputVideoMobileMp4 =  videoAltMobile ? `<source src="${videoAltMobile}" type="video/mp4">`:'';

        // overwrite empty sources with the other video source
        if (outputVideo === '') {
            if (outputVideoMobile !== '') {
                outputVideo = outputVideoMobile;
            }
        }
        if (outputVideoMobile === '') {
            if (outputVideo !== '') {
                outputVideoMobile = outputVideo;
            }
        }
        if (outputVideoMp4 === '') {
            if (outputVideoMobileMp4 !== '') {
                outputVideoMp4 = outputVideoMobileMp4;
            }
        }
        if (outputVideoMobileMp4 === '') {
            if (outputVideoMp4 !== '') {
                outputVideoMobileMp4 = outputVideoMp4;
            }
        }

        // prevent video slides from playing when not active
        if (videoEl.closest('.swiper-slide:not(.swiper-slide-active)')) {
            return;
        }

        // detect if mobile and append source tags  
        if (window.innerWidth < window.innerHeight) {
            videoEl.innerHTML = `
                ${outputVideoMobile}
                ${outputVideoMobileMp4}
            `;
            if(!outputVideoMobile && !outputVideoMobileMp4) {
                videoEl.innerHTML = `
                    ${outputVideo}
                    ${outputVideoMp4}
                `;
            }
        } else {
            videoEl.innerHTML = `
                ${outputVideo}
                ${outputVideoMp4}
            `;
            if(!outputVideo && !outputVideoMp4) {
                videoEl.innerHTML = `
                    ${outputVideoMobile}
                    ${outputVideoMobileMp4}
                `;
            }
        }
        videoEl.play();
    }
}
